import { Component, Input } from '@angular/core';
import { BundleType, ImageModel, NodeModel, EntityTypeId } from '../../models';


@Component({
    selector: 'lib-content-card',
    templateUrl: './content-card.component.html',
    styleUrls: ['./content-card.component.scss'],
    standalone: false
})
export class ContentCardComponent {
  @Input() public set item(value: NodeModel & { mediaImage: ImageModel, time: number }) {
    this._item = value ? this.mapItemWithBundle(value) : null;
  }

  public get item() {
    return this._item;
  }

  public contentBundle: BundleType;

  private _item: NodeModel & { mediaImage: ImageModel, time: number };


  private mapItemWithBundle(value: NodeModel & { mediaImage: ImageModel; time: number }) {
    const isContentGroup = value.entityTypeId === EntityTypeId.CONTENT_GROUP;

    return {
      ...value,
      bundle: value.bundle ?? (isContentGroup ? BundleType.CONTENT_GROUP : null),
      title: value.title ?? value.name
    };
  }
}
